import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPenToSquare } from '@fortawesome/fontawesome-pro';
import { faEdit } from '@fortawesome/free-regular-svg-icons';
import { IMetricsTableHead } from '../MetricsTable';
import TimeframeDisplay from './TimeframeDisplay/TimeframeDisplay';
import TimeframeManager from './TimeframeManager/TimeframeManager';
import {
  TimeframeEditButton,
  MetricsTableHeadContainer,
  TimeframeOverlay,
  PopperTooltipWrapper,
  MobileTimeframeManagerWrapper,
  MobileTimeframeManagerContainer,
} from './MetricsTableHead.styled';
import { PopperTooltip } from '@emarketer/componentlibrary';
import { useScrollBlock } from '../../../../helpers/hooks/useScrollBlock';
import { useWindowSize } from '../../../../helpers/hooks/useWindowSize';

const TableHead: React.FC<IMetricsTableHead> = (props) => {
  const { maximum, availableTimes, templateId, collectionId, headers, period, windowSize, loadTimeframe } = props;

  const [showPicker, setShow] = useState(false);
  const isMobile = useWindowSize().isMobile;
  const [blockScroll, allowScroll] = useScrollBlock();

  useEffect(() => {
    if (showPicker) blockScroll();
    else allowScroll();

    return () => {
      allowScroll();
    };
  }, [showPicker]);

  const setShowPicker = () => {
    setShow(!showPicker);
  };

  const timeframeManager = (
    <TimeframeManager
      availableTimes={availableTimes}
      maximum={maximum}
      headers={headers}
      toggleTimepicker={setShowPicker}
      period={period}
      templateId={templateId}
      collectionId={collectionId}
      loadTimeframe={loadTimeframe}
      isMobile={isMobile}
    />
  );

  return (
    <MetricsTableHeadContainer>
      {showPicker && <TimeframeOverlay onClick={() => setShowPicker()} />}
      <TimeframeDisplay headers={headers} open={showPicker} period={period} windowSize={windowSize} />
      {isMobile && (
        <MobileTimeframeManagerWrapper>
          <td>
            <TimeframeEditButton buttonType="none" onClick={setShowPicker}>
              <FontAwesomeIcon width={14} icon={faPenToSquare || faEdit} />
              Edit Timeframe
            </TimeframeEditButton>
            {showPicker && <MobileTimeframeManagerContainer>{timeframeManager}</MobileTimeframeManagerContainer>}
          </td>
        </MobileTimeframeManagerWrapper>
      )}
      {!isMobile && (
        <PopperTooltipWrapper>
          <PopperTooltip
            distance={30}
            placement="bottom"
            showPopper={showPicker}
            target={
              <TimeframeEditButton buttonType="none" onClick={setShowPicker}>
                <FontAwesomeIcon width={14} icon={faPenToSquare || faEdit} />
                Edit Timeframe
              </TimeframeEditButton>
            }
            controlShow
          >
            {timeframeManager}
          </PopperTooltip>
        </PopperTooltipWrapper>
      )}
    </MetricsTableHeadContainer>
  );
};

export default TableHead;
